import CustomView from "../../model2/custom-view/custom-view"
import ProjectSession from "../../model2/project/project-session"

export default function Views_addInitialProjectToSettings(view: CustomView) {
    // add parent project into settings projects if any and is allowed
    if (view.parentProjectId) {
        const project: ProjectSession = gd.session.projects.get(view.parentProjectId)!

        // check if project can be selected for settings projects
        if (project.acl.canCreateProject) {
            // create settings is view has none
            if (!view.settings) view.settings = {}

            // get current projects from settings if any
            const projects = view.settings?.projects || []

            // add parentProjectId to settings projects and filter out duplicates
            view.settings.projects = _.uniq([...projects, view.parentProjectId])
        }
    }
}